import React, { useState } from 'react';
import CompanyManagement from '../components/admin/CompanyManagement';
import UserManagement from '../components/admin/UserManagement';
import RoomInfo from '../components/admin/RoomInfo';
import { useAuth } from '../context/AuthContext';
import { useNavigate } from 'react-router-dom';
import '../styles/AdminPage.css';

/**
 * 管理ページ（システム管理者専用）
 */
const AdminPage = () => {
  const { user, isSystemAdmin } = useAuth();
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState('companies'); // 'companies' | 'users' | 'rooms'

  // システム管理者以外はアクセス不可
  if (!isSystemAdmin()) {
    return (
      <div className="admin-page-container">
        <div className="access-denied">
          <h2>アクセス拒否</h2>
          <p>このページへのアクセス権限がありません。</p>
          <button onClick={() => navigate('/calendar')} className="btn-primary">
            カレンダーに戻る
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="admin-page-container">
      <header className="admin-header">
        <h1>管理</h1>
        <p>企業・ユーザー・会議室情報の管理/閲覧を行います</p>
      </header>

      {/* タブナビゲーション */}
      <div className="admin-tabs">
        <button
          className={`tab-button ${activeTab === 'companies' ? 'active' : ''}`}
          onClick={() => setActiveTab('companies')}
        >
          企業管理
        </button>
        <button
          className={`tab-button ${activeTab === 'users' ? 'active' : ''}`}
          onClick={() => setActiveTab('users')}
        >
          ユーザー管理
        </button>
        <button
          className={`tab-button ${activeTab === 'rooms' ? 'active' : ''}`}
          onClick={() => setActiveTab('rooms')}
        >
          会議室情報
        </button>
      </div>

      {/* タブコンテンツ */}
      <div className="admin-content">
        {activeTab === 'companies' && (
          <div className="fade-enter">
            <CompanyManagement />
          </div>
        )}
        {activeTab === 'users' && (
          <div className="fade-enter">
            <UserManagement />
          </div>
        )}
        {activeTab === 'rooms' && (
          <div className="fade-enter">
            <RoomInfo />
          </div>
        )}
      </div>
    </div>
  );
};

export default AdminPage;
